import CardLayout from '@/components/common/CardLayout';
import InputField from '@/components/common/InputField';
import Modal from '@/components/common/modals/Modal';
import ModalManager, { useModal } from '@/components/ModalManager';
import { useTrackModalShown } from '@/services/analytics/useTracking';
import { useMutation } from '@apollo/client';
import { ExternalFinancialEntity, getName } from '@common/financialEntities';
import { UpdateFinancialEntityDocument } from '@common/graphql/generated';
import { useState } from 'react';

export interface RenameModalProps {
    financialEntity: ExternalFinancialEntity;
}

export const showRenameModal = (props: RenameModalProps) =>
    ModalManager.show(RenameModal, props);

const RenameModal = ModalManager.create<RenameModalProps>(
    ({ financialEntity: fe }) => {
        useTrackModalShown('Rename Financial Entity');

        const modal = useModal();
        const [name, setName] = useState(getName(fe));

        const [updateFE, { loading }] = useMutation(
            UpdateFinancialEntityDocument
        );

        return (
            <Modal size="sm" isOpen={modal.visible} onClose={modal.remove}>
                <CardLayout
                    title={`What do you want to name this account?`}
                    primaryButtonText="Save"
                    onPrimaryButton={() => {
                        updateFE({
                            variables: {
                                id: fe.id,
                                patch: {
                                    name,
                                },
                            },
                        }).then(modal.remove);
                    }}
                    isPrimaryButtonLoading={loading}
                    onSecondaryButton={modal.remove}
                    onClickPrimaryEvent="Rename Financial Entity Modal - Save Button Clicked"
                    onClickSecondaryEvent="Rename Financial Entity Modal - Cancel Button Clicked"
                >
                    <InputField
                        label=""
                        name="name"
                        type="text"
                        onChange={setName}
                        value={name}
                        inputProps={{
                            fontSize: 'lg',
                            variant: 'flushed',
                        }}
                        tabIndex={1}
                    />
                </CardLayout>
            </Modal>
        );
    }
);

export default RenameModal;
